// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from '../src/Login/login';
import DashboardPage from '../src/adminPages/Dashboard';
import Reportes from '../src/adminPages/Reportes';
import GestionCam from '../src/adminPages/Camaras';
import GestionReser from '../src/adminPages/Gestion_de_reservas';
import GestionSubs from '../src/adminPages/Gestion_de_subscripciones';
import GestionUser from '../src/adminPages/Gestion_de_usuarios';
import GestionPar from '../src/adminPages/Gestion_parqueo';
import Form from '../src/adminPages/Forms';
import Chats from '../src/adminPages/Chats';
import ProtectedRoute from '../src/services/protectedRoute';
// Importa tu página de usuario cuando la crees
import UserDashboard from '../src/userPages/DashboardUser';
import Inicio from '../src/userPages/inicio';
import ReservaParqueo from '../src//userPages/Reservas';
import TiquetesH from '../src/userPages/TitquetesHisto';
import Payment from '../src/userPages/Pago';
import ProfileScreen from '../src/userPages/Perfil';

function App() {
  return (
    <Router>
      <Routes>
        {/* Ruta pública - Login */}
        <Route path="/" element={<LoginPage />} />

        {/* Rutas protegidas para admin y clientService */}
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute allowedRoles={['Admin', 'ClientService',"SuperAdmin"]}>
              <DashboardPage />
            </ProtectedRoute>
          }
        >
          <Route path="reportes" element={<Reportes />} />
          <Route path="usuarios" element={<GestionUser />} />
          <Route path="reservas" element={<GestionReser />} />
          <Route path="subscripciones" element={<GestionSubs />} />
          <Route path="camaras" element={<GestionCam />} />
          <Route path="parqueo" element={<GestionPar />} />
          <Route path="forms" element={<Form />} />
          <Route path="chats" element={<Chats />} />
        </Route>

        {/* Ruta protegida para usuarios normales */}

        <Route
          path="/user-dashboard/*"
          element={
            <ProtectedRoute allowedRoles={['UserApp']}>
              <UserDashboard />
            </ProtectedRoute>
          }
        >
          <Route path="inicio" element={<Inicio />} />
          <Route path="reservas" element={<ReservaParqueo />} />
          <Route path="tiquetes" element={<TiquetesH />} />
          <Route path="payment" element={<Payment />} />
          <Route path="personal" element={<ProfileScreen />} />
        </Route>

      </Routes>
    </Router>
  );
}

export default App;